import { apiClient } from "../../../Utilities/apiClient";
import { Version, VersionStatus } from "../../../Resources/Data/Versions";

export const versionService = {
    getAllVersions: (): Promise<{ data: { versions: Version[] } }> =>
        apiClient.get('/versions'),

    createVersion: (version: string): Promise<{ data: Version }> =>
        apiClient.post('/versions', { version }),

    updateVersionStatus: (id: number, status: VersionStatus): Promise<{ data: Version }> =>
        apiClient.patch(`/versions/${id}`, { status }),

    deleteVersion: (id: number): Promise<{ data: { success: boolean } }> =>
        apiClient.delete(`/versions/${id}`),

    validateVersionString: (version: string): { isValid: boolean; error?: string } => {
        const regex = /^\d+\.\d+\.\d+$/;
        if (!regex.test(version)) {
            return { isValid: false, error: 'Version must be in the format X.Y.Z (e.g., 1.0.0)' };
        }
        return { isValid: true };
    }
};
